import { OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from '@app/shared/utils';
import { OccurencesService } from '@app/occurences/occurences.service';
import { CONSTANTS } from '@app/shared/constants';
import { SnackbarService } from '@app/shared/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@app/core/language/language.service';
var OccurenceListCommentsComponent = /** @class */ (function () {
    function OccurenceListCommentsComponent(iconRegistry, sanitizer, utils, occurenceService, _snackbarService, translate, languageService) {
        if (translate === void 0) { translate = null; }
        this.utils = utils;
        this.occurenceService = occurenceService;
        this._snackbarService = _snackbarService;
        this.translate = translate;
        this.languageService = languageService;
        this.showLoading = false;
        this.comments = [];
        this.errorDownloadFile = false;
        this.firstLoading = 1;
        /** FIXME: Não deveria ser necessário usar o @ngx-translate da forma abaixo.
      Voltamos o codigo anterior, agora refatorado, ja que alguns componentes nao sao traduzidos sem ele
      */
        translate.addLangs(this.languageService.getSiteLanguageCodes());
        translate.use(this.languageService.siteLanguage);
        iconRegistry.addSvgIcon('atachment', sanitizer.bypassSecurityTrustResourceUrl('assets/img/atachment.svg'));
    }
    OccurenceListCommentsComponent.prototype.ngOnInit = function () {
        this.firstLoading = 1;
    };
    OccurenceListCommentsComponent.prototype.loadComments = function () {
        var _this = this;
        if (this.firstLoading == 1 && this.comments.length == 0) {
            this.showLoading = true;
            this.firstLoading++;
        }
        this.occurenceService.getCommentsByOccurrenceById(this.occurrenceId).subscribe(function (occurrenceResponse) {
            _this.comments = occurrenceResponse;
            _this.showLoading = false;
            _this.adjusteDataComments(_this.comments);
        });
    };
    OccurenceListCommentsComponent.prototype.adjusteDataComments = function (comments) {
        var _this = this;
        if (comments && comments.length > 0) {
            comments.forEach(function (comment) {
                var width = 100;
                var lineBreak;
                var maxCaracters = 400;
                var maxLenghtNameDocument = 15;
                var maxLines = 2;
                if (comment.description.length > maxCaracters) {
                    width = width - 10;
                    comment.simplifiedComment = comment.description.substring(0, maxCaracters);
                }
                else {
                    lineBreak = comment.description.split('\n');
                    if (lineBreak.length > 2) {
                        comment.showViewMore = true;
                    }
                }
                if (comment.storedDocument && comment.storedDocument.length > 0) {
                    width = width - 10;
                    comment.storedDocument.forEach(function (document) {
                        var infoNameDocument = document.documentName ? document.documentName.split('.') : [''];
                        document.textSize = _this.utils.getSizeFileText(document.fileSize ? document.fileSize.toString() : '');
                        if (infoNameDocument[0].length > maxLenghtNameDocument) {
                            document.simplifiedName = infoNameDocument[0].substring(0, maxLenghtNameDocument) + "..." + infoNameDocument[1];
                        }
                    });
                }
                comment.width = width.toString() + "%";
                comment.showCompletComment = false;
            });
        }
    };
    OccurenceListCommentsComponent.prototype.downloadDocumentOfCommentById = function (id) {
        var _this = this;
        this.occurenceService.downloadDocumentOfCommentById(id)
            .subscribe(function (resp) {
            _this.errorDownloadFile = false;
            var body = resp.body;
            var fileName = body.fileName, contentFile = body.contentFile;
            var blob = _this.utils.convertByteJsonToBlob(contentFile);
            _this.utils.downloadFileBlob(blob, fileName);
        }, function (err) {
            _this.utils.showSnackbar(CONSTANTS.ERROR_DOWNLOAD_FILE_COMMENT);
        });
    };
    OccurenceListCommentsComponent.prototype.handleCountComments = function () {
        return this.comments.length === 0 ? this.countComments : this.comments.length;
    };
    return OccurenceListCommentsComponent;
}());
export { OccurenceListCommentsComponent };
